<template>
  <div class="card border-0">
    <async-animation :async-anim-props="{ name: contents.anim.name, delay: contents.anim.delay }" class="card-img-top" v-if="contents.anim"></async-animation>
    <img :src="contents.img.path" :class="getImgClasses()" v-if="contents.img"/>
    <div class="card-body">
      <h5 :class="getNameClasses()">{{ getText('name') }}</h5>
      <p :class="getDescClasses()">{{ getText('desc') }}</p>
    </div>
  </div>
</template>

<script>
import AsyncAnimation from '@/components/AsyncAnimation.vue'

export default {
  name: 'card',
  components: {
    AsyncAnimation,
  },
  props: {
    contents: {
      type: Object,
      required: true,
    },
  },
  methods: {
    arrayToClasses: function (array) {
      return array.reduce((map, item) => { map[item] = true; return map }, {})
    },
    getImgClasses: function () {
      return this.contents.img.classes ? this.arrayToClasses(this.contents.img.classes) : {'img': true, 'card-img-top': true}
    },
    getNameClasses: function () {
      return this.arrayToClasses(['card-title', 'text-center'].concat(this.contents.name.classes || []))
    },
    getDescClasses: function () {
      if (typeof this.contents.desc == 'undefined') {
        this.contents.desc = {}
      }
      return this.arrayToClasses(['card-text'].concat(this.contents.desc.classes || []))
    },
    getText: function (key) {
      if (typeof this.contents[key] == 'string') {
        return this.contents[key]
      } else if (typeof this.contents[key] == 'object') {
        return this.contents[key].text
      }
    },
  },
}
</script>

<style lang="scss">
.card {
  background-color: inherit;
}
.strong {
  font-weight: bold;
}
.little-small {
  font-size: 95%;
}
</style>



// WEBPACK FOOTER //
// src/components/Card.vue